// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_k8-0";
export var discountCodeInput = "_k8-1";